import React from "react";

import AppIntlProvider from "./components/app-intl-provider";
import AntdConfigProvider from "./components/antd-config-provider";

import { App as AntdApp } from "antd";

import AppRouterProvider from "./components/app-router-provider";
import AppConfigProvider from "./components/app-config-provider";

import "minireset.css";

function App() {
	return (
		<AppConfigProvider>
			<AppIntlProvider>
				<AntdConfigProvider>
					<AntdApp>
						<AppRouterProvider />
					</AntdApp>
				</AntdConfigProvider>
			</AppIntlProvider>
		</AppConfigProvider>
	);
}

export default App;
